import { publicRoutePaths } from "@/routes/public.routes.config";
import React from "react";
import { Link } from "react-router-dom";

const TermsAndConditionsLogistic = () => {
  return (
    <div>
      <p>
        <b>Effective Date:</b> 25 Jan 2025
      </p>
      <p>
        <b>Last Updated:</b> 2 Dec 2024
      </p>

      <p>
        Welcome to <b>Orex Trade World INC</b>. These Logistics Terms & Conditions (“Terms”) govern the obligations, rights and responsibilities of <b>Logistics Partners</b> using the OrexTrade Network (Network). By providing or using logistics services via the Network, you agree to comply with these Terms, in addition to OrexTrade’s general Terms & Conditions.
      </p>

      <h2 className="head">1. Registration and Verification</h2>
      <p>Logistics Partners must:</p>
      <ul>
        <li>
          Accurately and truthfully complete the registration form.
        </li>
        <li>
          Submit all necessary legal and business documentation, including business registration and tax certificates, for verification.
        </li>
        <li>
          Immediately inform OrexTrade of any updates or changes to registered information.
        </li>
        <li>
          Maintain active verification status to access leads and financial protection benefits.
        </li>
      </ul>


      <h2 className="head">2. Roles and Responsibilities</h2>
      <p>Logistics Partners agree to:</p>
      <ul>
        <li>
          Provide reliable, transparent and secure transportation services.
        </li>
        <li>
          Comply with all applicable federal, state and local shipping regulations, including U.S. Customs, Department of Transportation and export control laws.
        </li>
        <li>
          Clearly communicate pricing, terms and conditions with all involved parties.
        </li>
        <li>
          Responsibly handle all leads provided by OrexTrade and obtain explicit approval before subcontracting any assignments.
        </li>
        <li>
          Notify OrexTrade promptly of service disruptions, shipment delays or changes in transportation arrangements.
        </li>
        <li>
          Provide valid rate quotations upfront without hidden charges and refrain from holding cargo or demanding additional payments after shipment commencement.
        </li>
      </ul>

      <h2 className="head">3. Pricing and Rates</h2>
      <ul>
        <li>
          Logistics Partners must provide a detailed breakdown of pricing for full transparency.
        </li>
        <li>
          Once rates are confirmed by OrexTrade and agreed upon by the User, rates are binding.
        </li>
        <li>
          Any changes or additional charges requested by Buyers or Suppliers must be communicated and agreed upon in writing. Logistics Partners are not responsible for these unless confirmed in writing.
        </li>
      </ul>

      <h2 className="head">4. Benefits Provided</h2>
      <p>Verified Logistics Partners will receive:</p>
      <ul>
        <li>
          Direct leads from verified Buyers and Suppliers.
        </li>
        <li>
          Global brand promotion via OrexTrade network.
        </li>
        <li>
          Access to advanced shipment analytics and detailed insights.
        </li>
        <li>
          Dedicated landing pages to showcase services.
        </li>
        <li>
          Limited exclusive rights to operate at specific port locations, subject to agreement and availability.
        </li>
        <li>
          The Network shall award 20 <b>credits per day</b> for <b>unique profile views</b>.
        </li>
      </ul>

      <h2 className="head">5. Secure Trade and Ethical Conduct</h2>
      <ul>
        <li>
          Secure Trade Guarantees apply only when logistics services are performed by Orex Trade-verified partners.
        </li>
        <li>
          Logistics Partners must maintain high ethical standards and comply with U.S. anti-bribery, anti-corruption and trade compliance laws.
        </li>
        <li>
          Cargo cannot be released or handled without explicit authorization from OrexTrade.
        </li>
      </ul>

      <h2 className="head">6. Termination of Partnership</h2>
      <p>OrexTrade may terminate Logistics Partner accounts for:</p>
      <ul>
        <li>
          Non-compliance with these Terms.
        </li>
        <li>
          Providing false, misleading or fraudulent information.
        </li>
        <li>
          Violations of ethical standards or repeated service failures.
        </li>
      </ul>

      <h2 className="head">7. Dispute Resolution</h2>
      <ul>
        <li>
          Any disputes shall first be addressed through good-faith negotiation between parties.
        </li>
        <li>
          Unresolved disputes shall be resolved in <b>state or federal courts located in Fulton County, Georgia, USA</b> and Logistics Partners consent to exclusive jurisdiction in such courts.
        </li>
      </ul>

      <h2 className="head">8. Amendments and Updates</h2>
      <ul>
        <li>
          OrexTrade may update these Terms periodically.
        </li>
        <li>
          Significant updates will be communicated via email or Network notifications.
        </li>
        <li>
          Continued use after updates constitutes acceptance.
        </li>
      </ul>

      <h2 className="head">9. Indemnification</h2>
      <p>Logistics Partners agree to indemnify, defend and hold OrexTrade harmless from any claims, liabilities, damages or expenses arising from their operations or violations of these Terms.</p>

      <h2 className="head">10. Force Majeure</h2>
      <p>OrexTrade is not liable for delays or failures caused by events beyond reasonable control, including natural disasters, governmental actions, pandemics, strikes or technological failures.</p>

      <h2 className="head">11. Confidentiality</h2>
      <p>Logistics Partners must maintain confidentiality of all sensitive business information unless authorized to disclose. Breach may result in termination and legal action.</p>

      <h2 className="head">12. Financial Protection (“Gold Shield Protection Plan”)</h2>
      <h3>12.1 Definitions</h3>
      <ul>
        <li>
          OrexTrade administers the <b>Gold Shield Protection Plan</b> (“Plan”), providing financial protection for Eligible Members against non-payment of transaction charges.
        </li>
        <li>
          <b>Eligible Members:</b> Premium or Premium Plus subscribers. Starter or Standard Plan Members are non-covered.
        </li>
        <li>
          <b>Transaction:</b> Business activity between two or more Eligible Members via OrexTrade.
        </li>
        <li>
          <b>Gold Shield Protection Fund (GSPF a/c):</b> Official account for managing claims.
        </li>
      </ul>

      <h3>12.2 Eligibility</h3>
      <ul>
        <li>
          Only Eligible Members with active verification at the time of transaction qualify.
        </li>
        <li>
          Transactions with non-members, non-enrolled offices or members in Starter/Standard Plans are not covered.
        </li>
      </ul>

      <h3>12.3 Compliance</h3>
      <ul>
        <li>
          Transactions must comply with all applicable U.S. laws, including OFAC, BSA/AML, EAR, ITAR, FTR and CBP regulations.
        </li>
        <li>
          Transactions violating laws, sanctions or involving illegal commodities are excluded.
        </li>
      </ul>

      <h3>12.4 Coverage</h3>
      <ul>
        <li>
          Coverage applies to non-payment of transaction charges, up to USD $50,000 for Premium Plan, USD $100,000 for Premium Plus.
        </li>
        <li>
          Coverage excludes goods, cargo, shipment costs, fees, demurrage, fines, force majeure or services provided by carriers.
        </li>
        <li>
          Transactions must involve advance order approval, rate confirmation and an internal trade agreement prior to execution.
        </li>
      </ul>

      <h3>12.5 Member Obligations</h3>
      <ul>
        <li>
          Maintain active membership.
        </li>
        <li>
          Provide accurate documentation for claims.
        </li>
        <li>
          Ensure compliance with U.S. trade laws, customs and export regulations.
        </li>
      </ul>

      <h3>12.6 Claims</h3>
      <ul>
        <li>
          File claims within 90 days of invoice with full supporting documentation.
        </li>
        <li>
          Claims outside the timeline, involving non-eligible Members or conducted outside the OrexTrade network are excluded.
        </li>
      </ul>

      <h3>12.7 Fund Administration</h3>
      <ul>
        <li>
          GSPF a/c is funded by a percentage of membership fees.
        </li>
        <li>
          Maximum payout per year is 70% of available fund balance; remaining claims are settled FIFO.
        </li>
      </ul>

      <h3>12.8 Limitations</h3>
      <ul>
        <li>
          Plan does not cover cargo, carrier errors, fraud, hacking or same-country transactions.
        </li>
        <li>
          Members must mitigate losses; failure may reduce claim payout.
        </li>
      </ul>

      <h3>12.9 Claim Approval</h3>
      <ul>
        <li>
          OrexTrade investigates claims; Members must cooperate.
        </li>
        <li>
          False claims may result in denial, suspension or termination.
        </li>
      </ul>

      <h3>12.10 Termination of Coverage</h3>
      <ul>
        <li>
          Coverage terminates upon non-renewal, suspension, termination or removal from membership directory.
        </li>
      </ul>

      <h3>12.11 Independent Operations</h3>
      <ul>
        <li>
          OrexTrade shall not be liable for any interactions or disputes occurring through third-party networks or outside the network. Any exception shall be subject to OrexTrade’s review and approval.
        </li>
      </ul>

      <h3>12.12 Governing Law & Jurisdiction</h3>
      <ul>
        <li>
          Terms governed by <b>U.S. federal law</b> and the <b>laws of the State of Georgia, USA</b>.
        </li>
        <li>
          All disputes resolved exclusively in <b>state or federal courts in Fulton County, Georgia, USA</b>.
        </li>
      </ul>

    <h2 className="head">13. Refund</h2>
       <h3>13.1 Membership Fees</h3>
      <ul>
        <li>
         All membership fees are <b>non-refundable</b> once payment has been received.  
        </li>        
      </ul>
      <h3>13.2 Exceptional Refund Requests</h3>
      <ul>
        <li>
         Refund requests will only be considered in genuine and exceptional circumstances, at the sole discretion of Orex Trade World INC.
         <ul>
          <li><b>Before the Membership Agreement is executed or the verification/enrollment process has started:</b> If a refund request is approved, a maximum refund of <b>50% of the membership fee</b> may be issued. The remaining amount will be retained to cover administrative, processing, and onboarding costs.</li>
          <li>After the Membership Agreement has been executed or the verification, enrollment, or membership activation process has begun: <b>No refund will be issued.</b></li>
          </ul>  
        </li>        
      </ul>

      <h2 className="head">14. Contact Information</h2>
      <ul>
        <li>
          <b>Email: </b>
          <a href={`mailto:${process.env.REACT_APP_SUPPORT_MAIL}`} title={process.env.REACT_APP_SUPPORT_MAIL}>{process.env.REACT_APP_SUPPORT_MAIL}</a>
        </li>
        <li>
          <b>Website: </b> <Link to={publicRoutePaths.HOME.path} title="www.orextrade.com">www.orextrade.com </Link>
        </li>
        <li>
          <b>WhatsApp: </b> {process.env.REACT_APP_WHATSAPP_NUMBER}
        </li>
      </ul>
    </div>
  );
}

export default TermsAndConditionsLogistic;
